// Every mushaf page has its own QCF v1 font (p1..p604). Loads are cached so
// revisiting or preloading a page is free.
const loaded = new Map<string, Promise<void>>();

function loadFont(family: string, file: string) {
	let promise = loaded.get(family);
	if (!promise) {
		promise = new FontFace(family, `url(/fonts/${file})`)
			.load()
			.then((face) => {
				document.fonts.add(face);
			})
			.catch((err) => {
				loaded.delete(family);
				throw err;
			});
		loaded.set(family, promise);
	}
	return promise;
}

// The surah header fonts are declared with @font-face in index.html; loading
// them through document.fonts shares that one face instead of adding another.
// The sample text is a codepoint the font covers, so the right face loads.
const HEADER_FONTS = [
	["surah-name", ""],
	["quran-common", ""],
] as const;

const headerFontsReady = () =>
	HEADER_FONTS.every(([family, text]) => document.fonts.check(`16px ${family}`, text));

let headerFonts: Promise<void> | null = null;
function loadHeaderFonts() {
	headerFonts ??= Promise.all(
		HEADER_FONTS.map(([family, text]) => document.fonts.load(`16px ${family}`, text)),
	)
		.then(() => undefined)
		.catch((err) => {
			headerFonts = null;
			throw err;
		});
	return headerFonts;
}

export function isPageFontLoaded(page: number) {
	return document.fonts.check(`16px p${page}`) && headerFontsReady();
}

export function loadPageFont(page: number) {
	return Promise.all([loadFont(`p${page}`, `p${page}.woff2`), loadHeaderFonts()]).then(
		() => undefined,
	);
}
